/**
 *  S T A T E
 *  https://vuex.vuejs.org/en/state.html
 */

const state = {
  /** generated token using credentials */
  token: '',
  account: {},
  facility: {},
  facilities: [],
  programs: [],
  facilityThreshold: 0,
  ncpCeiling: 0,
  utility: {},
  iso: {},
  notice: {}
}

export default state
